import styled from 'styled-components';
import { RouterLink } from '@redux-first-router-link';
import LockSolid from '@simplywallst/ui-core/icons/LockSolid';
import { Badge } from '@simplywallst/ui-core';

export const Td = styled.td`
  && {
    padding: 10px 8px;
  }
`;

export const Truncate = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FakeHeader = styled.caption`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  && {
    padding: 10px 16px;
  }
`;

export const HiddenTr = styled.tr`
  opacity: 0;
  pointer-events: none;
`;

export const Link = styled(RouterLink)`
  margin-block: -3px;
  && {
    text-overflow: unset;
  }
`;

export const SmallBadge = styled(Badge)`
  font-size: 11px;
`;

export const LockIcon = styled(LockSolid)`
  display: block;
  margin-left: auto;
`;
